import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AdminRoute = ({ element: Component }) => {
    const { authToken } = useAuth();

    console.log("AdminRoute - vérification admin:", authToken);

    // Vérifier si l'utilisateur est connecté et admin
    if (!authToken.token || !authToken.isAdmin) {
        console.log("Accès refusé - non admin");
        return <Navigate to="/" replace />;
    }

    console.log("Accès admin autorisé");
    return <Component />;
};

export default AdminRoute;